import { ItemAlertStatus } from 'constants/item';
export const transformAlertToItemStatus = alert => {
  switch (alert) {
    case ItemAlertStatus.DarkGray:
      return 'hidden_from_catalog';

    case ItemAlertStatus.DelayedPublication:
      return 'delayed';

    default:
      return alert;
  }
};